export default "__VITE_ASSET__pDHPRtj3__"